import type { QueryClient } from '@tanstack/react-query';

/**
 * Every cached view that shows a scheduling category, by the first segment of its query key. Adding,
 * renaming, recolouring or deleting a category changes what each of them shows: the composer's list, the
 * Scheduler page's schedules, the pills on the post lists, a post, a campaign's cards and the Trash, and
 * the times a post's Schedule tab suggests (a deleted category's posts fall back to General).
 *
 * `posting-schedule` is here so a Scheduler page opened again later does not start from a copy that
 * still lists a deleted category, or misses a new one: that page builds its editor once from what is
 * cached, so the cache has to be current by then.
 */
export const CATEGORY_VIEW_KEYS = [
  'scheduling-categories',
  'posting-schedule',
  'posts',
  'post',
  'campaign',
  'trash',
  'schedule-suggestions',
] as const;

/** Refresh, for one workspace, every view that shows a category. Other workspaces' caches are left alone. */
export async function invalidateCategoryViews(queryClient: QueryClient, tenantKey: string): Promise<void> {
  await Promise.all(
    CATEGORY_VIEW_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: [key, tenantKey] })),
  );
}
